import type { ReactNode } from 'react';

type Props = {
  /** 見出し (Amazon商品情報 / 商品情報) */
  title: string;
  /** 見出し行の右端に置くアクション (再取得ボタン等)。無ければ右側の枠を出さない */
  headerActions?: ReactNode;
  /** テーブル本体 (details-table)。中身 (表示専用 / 閲覧・編集) はページごとに違うのでそのまま渡す */
  children: ReactNode;
  /** 下部のボタン行 (削除 / 編集 / キャンセル / 保存)。取り消し系は左・主アクションは右 (space-between) */
  footer?: ReactNode;
};

/**
 * 商品情報セクションの枠組み (Amazon / マニュアル共通): 見出し行 + テーブル + 下部ボタン行。
 * 見出し行は左に見出し・右にアクション。中身は統合しない (計画 4.5)。
 */
export function ProductDetailsSection({ title, headerActions, children, footer }: Props) {
  return (
    <>
      <div className="product-details-only">
        <div className="product-details-header">
          <h2>{title}</h2>
          {headerActions && <div className="product-details-header-actions">{headerActions}</div>}
        </div>
        {children}
      </div>
      {footer && <div className="bottom-actions bottom-actions--no-divider">{footer}</div>}
    </>
  );
}
